<template>
  <div class='indexbox'>
    <wallet-head show_type="3" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false" url="/api/v1/user/level"
      :data="{}">
      <div-padding>
        <div-card bg='#242424' @click="router('wodlicai')">
          <van-cell is-link>
            <template #title>
              <div-text color="#fff">{{ $t('我的理财') }}</div-text>
            </template>
          </van-cell>
        </div-card>
      </div-padding>

      <!-- 单元格结束 -->
      <div class="bodybox">
        <div class="item" v-for="(item, index) in list" :key="index" @click="router(`licaidel?id=${item.id}`)">
          <img :src="item.img[0].url" alt="" v-if="item.img[0]">
          <img src="~@/assets/img/shuju1@2x.png" alt="" v-else>
          <div>
            <div class="top">
              <div class="top1">{{ item.name }}</div>
              <div class="top2">
                <div>{{ item.cycle }}{{ $t('天') }}</div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom1">
                <p>{{ $t('价格') }}</p>
                <p>{{ item.amount }}ACT</p>
              </div>
              <div class="bottom1">
                <p>{{ $t('收益率') }}</p>
                <p>{{ item.rate }}%</p>
              </div>
              <div class="bottom2">{{ $t('参与理财') }}</div>
            </div>
            <div class="b">
              <van-progress :percentage="percentFun(item)" color="#ee0a24" track-color="#fff" />
            </div>
          </div>
        </div>
      </div>
    </vant-up-down>

    <van-popup class="popupcode" v-model="show_code" style="width: 76%;top:40%;" closeable>
      <div class="content">
        <p>{{ $t('交易密码') }}</p>
        <van-field v-model="password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
        <van-button block color="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)" :loading="loading" @click="pay">{{
          $t('确定') }}</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        page: 1,
        loading: false,
        finished: false,
        show_code: false,
        password: "",
        id: "",
      }
    },
    created() {
      this.up_down()
    },
    methods: {
      one(id) {
        this.id = id
        this.show_code = true
      },
      pay() {
        if (!this.password) return this.$toast(this.$t("请输入交易密码"))
        if (this.loading == true) {
          return this.$toast(this.$t("请勿重复提交"))
        }
        this.loading = true
        this.$post({
          url: "/api/v1/user/financial",
          data: {
            level_id: this.id,
            trade_password: this.password,
          },
          success: (res) => {
            this.password = ""
            this.show_code = false
            this.$toast(this.$t("参与成功"))
            setTimeout(() => {
              this.loading = false
            }, 2000)
          },
          tip: () => {
            this.password = ""
            this.show_code = false
            setTimeout(() => {
              this.loading = false
            }, 2000)
          },
        })
      },
      percentFun(data) {
        if (data.stock && data.sales) {
          let num = Number(data.stock) - Number(data.sales)
          return Number(num / Number(data.stock) * 100).toFixed(2)
        }
        return 100
      }
    },
  }
</script>
<style lang='less' scoped>
  .indexbox {
    width: 100%;
    padding: 0 0 40px;
    .bodybox {
      width: 100%;
      padding: 10px 15px;
      .item {
        width: 100%;
        background: #242424;
        border-radius: 6px;
        padding: 10px 15px;
        margin-bottom: 15px;
        display: flex;
        justify-content: flex-start;
        img {
          width: 19vw;
          height: 19vw;
          margin-right: 2vw;
        }
        .top {
          width: 63vw;
          display: flex;
          justify-content: space-between;
          .top1 {
            font-size: 4vw;
            color: #fff;
            font-weight: 550;
          }
          .top2 {
            border: #ceb082 1px solid;
            border-radius: 1vw;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0vw 2vw;
            div {
              font-size: 3.5vw;
              color: #ceb082;
            }
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 2vw;
          .bottom1 {
            p {
              font-size: 3.5vw;
              color: #999999;
              &:nth-child(2) {
                font-size: 4vw;
                color: #ceb082;
                font-weight: 550;
              }
            }
          }
          .bottom2 {
            background: #ceb082;
            border-radius: 1vw;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 3.5vw;
            font-weight: 550;
            color: #242424;
            padding: 0.5vw 1vw;
          }
        }
        .b {
          width: 100%;
          padding: 10px 0;
        }
      }
    }
  }
  .popupcode {
    background: #242424;
    box-shadow: 0px 3px 10px 1px rgba(255, 236, 209, 0.13);
    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
      >p {
        width: 100%;
        text-align: center;
        font-size: 15px;
        font-weight: 550;
        padding: 5px 0 30px;
      }
      /deep/.van-cell {
        background: #0f0f0f;
        border-radius: 6px;
        margin-bottom: 15px;
        padding: 3vw;
        .van-cell__title {
          width: 4em;
          color: #fff;
        }
        .van-field__control {
          color: #fff;
        }
      }
      .van-button {
        margin-top: 15px;
      }
    }
  }
</style>